var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_vm.isUserBuyerGroup(_vm.loggedUserData) || _vm.isOrderForConsultantHimself ? _c("UserFinalizeCart", {
    attrs: {
      baseModel: _vm.order,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminFinalizeCart", {
    attrs: {
      baseModel: _vm.order,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm.isConsultantOrHolding(_vm.loggedUserData) ? _c("ConsultantFinalizeCart", {
    attrs: {
      baseModel: _vm.order,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };